import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the pathname changes.
 * Mount once, inside <BrowserRouter>. Uses `instant` behavior so navigation
 * always lands at the top — smooth scroll on nav feels janky.
 *
 * Hash links (#foo) are preserved: if the URL has a hash we let the browser
 * scroll to the anchor instead of forcing top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the anchor handle it
    // Use requestAnimationFrame so it runs after the new route paints
    const id = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      // Fallback for browsers that don't accept 'instant'
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(id);
  }, [pathname, hash]);

  return null;
}
